import React, { useState } from 'react';
import { Navigate, useLocation, useNavigate } from 'react-router-dom';
import './admin.css';

export const useAdminSession = () => {
  const [state, setState] = React.useState({ loading: true, authenticated: false });

  React.useEffect(() => {
    fetch('/cms-api/auth/me', { credentials: 'same-origin' })
      .then((response) => setState({ loading: false, authenticated: response.ok }))
      .catch(() => setState({ loading: false, authenticated: false }));
  }, []);

  return state;
};

export const AdminGateway = () => {
  const session = useAdminSession();
  if (session.loading) return null;
  return <Navigate replace to={session.authenticated ? '/admin/edit' : '/admin/login'} />;
};

export const RequireAdmin = ({ children }) => {
  const session = useAdminSession();
  const location = useLocation();
  if (session.loading) return null;
  if (!session.authenticated) {
    return <Navigate replace to="/admin/login" state={{ from: location.pathname }} />;
  }
  return children;
};

const AdminLogin = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [username, setUsername] = useState('admin');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [submitting, setSubmitting] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setError('');
    setSubmitting(true);
    try {
      const response = await fetch('/cms-api/auth/login', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username, password }),
      });
      if (!response.ok) {
        setError('Invalid username or password.');
        return;
      }
      navigate(location.state?.from || '/admin/edit', { replace: true });
    } catch {
      setError('Login is temporarily unavailable.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <main className="admin-login-page">
      <form className="admin-login-card" onSubmit={submit}>
        <h1>AlphaCare Elite</h1>
        <input
          autoComplete="username"
          aria-label="Username"
          value={username}
          onChange={(event) => setUsername(event.target.value)}
        />
        <input
          autoComplete="current-password"
          aria-label="Password"
          type="password"
          value={password}
          onChange={(event) => setPassword(event.target.value)}
        />
        {error && <p role="alert">{error}</p>}
        <button disabled={submitting} type="submit">Sign in</button>
      </form>
    </main>
  );
};

export default AdminLogin;

